import { useEffect, useState } from 'react';
import NavOptions from './NavOptions';
import styles from './styles.module.scss';
import { Link, useNavigate } from 'react-router-dom';
import Button from './Button';

const Navheader = (props) => {

     const navigate = useNavigate();
    function Community(id, name, link) {
  this.id = id;
  this.name = name;
  this.link = link;
}

const communityArray = [];
let randomGameplays = [
    'https://youtu.be/-DgGZzdioj8?si=vRKFoukkzfcjw7r-',
'https://www.youtube.com/watch?v=TZNIZBBFP3s&list=PLFeQG23FKSOZ9CUIxm-vqpsUQp7IwBsgY&index=2',
'https://www.youtube.com/watch?v=KE67F53k3TE&list=PLRXCnVhMUS_zdURs4RdMqEyJ3iNnBbmu9&index=1',
'https://www.youtube.com/watch?v=3HQM-qnEbfE&list=PLtXEzvB19g0WDlMZBChegjs1lwClC6ekw',
'https://www.youtube.com/watch?v=w59b9KW01tg&list=PLtXEzvB19g0X_HPNaGvHBo0n1hbr4AmVr',
'https://youtu.be/lsbnBhxMVCY?si=lzNfpqaCNrssFF-4',
'https://www.youtube.com/watch?v=STgzBWV2rqs&list=PLcAXQSQengx4ZnHkmTTP8xDR6MJmHXTUG',
'https://www.youtube.com/watch?v=-bPkyF5KUIc&list=PLcAXQSQengx52ua67w1RiEFTwA0CiCKId',
'https://www.youtube.com/watch?v=ZnJFBJ1TpZY&list=PLRXCnVhMUS_zjxoBnLdWChGHir_mKQNMu',
'https://www.youtube.com/watch?v=Cu3SvGasdIs&list=PLRXCnVhMUS_yzDTM0AjVCmB43G1cHLPNA',
'https://www.youtube.com/watch?v=6GCaaMu7NkM&list=PLRnRUy2cRrt4etK0-ADsnsCgyP0afq7Tu',
'https://www.youtube.com/watch?v=XkKOgJ30zoc&list=PLn145z1hykyXgPa7Spjl5rD9I8huoBB__&index=16',
'https://www.youtube.com/watch?v=tYpMnWGoItY&list=PLGFBIGOt5uEimGl9ct_K9gwWL80vxTgFt'
];

let randomGameplay = Math.ceil(randomGameplays.length * Math.random()) - 1;
// console.log(randomGameplays[randomGameplay]);
communityArray.push(new Community(1,"Discord Server","https://discord.com/invite/BkFsXxauc4"));
communityArray.push(new Community(2,"Official Youtube Channel","https://www.youtube.com/@nevry-cards"));
communityArray.push(new Community(3,"Poof's Killergarten Gameplay",randomGameplays[randomGameplay]));
communityArray.push(new Community(4,"Ko-Fi","https://ko-fi.com/nevrycards"));
communityArray.push(new Community(5,"Gallery","/gallery"));
communityArray.push(new Community(6,"Divided Fate Items","/fateItems"));


  const [hovered, setHovered] = useState(false);  
  const [tim, setTim] = useState(false);
  const [cookie, setCookie] = useState(false);  
    const [newAdd, setNewAdd] = useState(false);  
       const [visAdd, setVisAdd] = useState(false);  
     let time;
     let whichAdd = "";
     if(localStorage.getItem("cardsOfHorror") == "true" && localStorage.getItem("cardsOfHorrorOk") != "true"){
        whichAdd = "coH";
     }
         if(localStorage.getItem("mwovOk") != "true"){
        whichAdd = "mwov";
     }
     
  
     useEffect(()=>{
           if(localStorage.getItem("cookie") == "ok"){
   setCookie(true);
           }
      
            if(localStorage.getItem("newAdd") == whichAdd){
                console.log(localStorage.getItem("newAdd"));
        setNewAdd(whichAdd);
           }else{
               setVisAdd(false);
            setTimeout(()=>{
    if(newAdd != whichAdd){
        setVisAdd(1);
          setTimeout(()=>{
    if(newAdd != whichAdd){
        setVisAdd(2);
       
    }
 },200);
    }
 },600);
           }
     
     },[]);
    const onHover = (e) => {
     
        let val = e.target.textContent.split(" ")[0];
        // console.log(val);
                  clearTimeout(time);
                  setTim(0);
               
        switch(val){
  
                case "Nevrycards":
                  
            setHovered(1);
            break;
            case "Games":
            setHovered(2);
            break;
            case "Community":
            setHovered(3);
            break;
            case "Passwords":
            setHovered(4);
            break;
            case "Support!":
            setHovered(5);
            break;
            case "Cards":
            
            setHovered(6);
            break;
        }
    }

     const afterHover = (e) => {
        time = setTimeout(()=>{
        setHovered(0);
        },300);
    
        
    }
       const cookieAdd = () => {
        localStorage.setItem('cookie','ok');
        setCookie(true);

    }

    const closeAdd = () => {
        localStorage.setItem('newAdd',whichAdd);
        if(whichAdd == "mwov"){
            localStorage.setItem('mwovOk',"true");
        }

          if(whichAdd == "coH"){
             localStorage.setItem('cardsOfHorrorOk',"true");
            }
            
        setNewAdd(whichAdd);
        setVisAdd(false);

    }

      const setAdd = () => {
        localStorage.setItem('newAdd','123');
        

    }

    const addAdd = () => {
        closeAdd();

    }

    return (
        <div className={`${styles.backgroundColorDark} ${props.xmas && styles['backgroundColorDark--xmas']} ${props.halloween && styles['backgroundColorDark--halloween']} ${styles[`width--90P`]} ${styles[`height--10P`]} ${styles[`align--middle`]} ${styles[`boxShadow`]}`}
        style={{
            position: "fixed",       
            top: '0%',
            marginTop: '.3%',
            borderRadius: '10px',
            zIndex: 2    
        }}
        >
            {(visAdd === false || whichAdd == "") ? '' : 
            <div>
   <div onClick={closeAdd} className={styles.addContainer} style={{
                zIndex: 998
               }}> 
               
            </div>
   <div className={`${styles.add} ${styles.backgroundColorDark} ${props.xmas && styles['backgroundColorDark--xmas']} ${props.halloween && styles['backgroundColorDark--halloween']}`} style={{
                       opacity: visAdd == 2 ? 1 : 0,
                       bottom: visAdd == 2 ? '-700%' : '0%'
               }}>
                {whichAdd == "mwov" && <div className={`${styles.addImg} ${styles['addImg--mwov']}`}></div>}
                {whichAdd == "keneBrini" && <div className={`${styles.addImg} ${styles['addImg--kenebrini']}`}></div>}
                {whichAdd == "coH" && <div className={`${styles.addImg} ${styles['addImg--coh']}`}></div>}
               
                           <div onClick={closeAdd} className={`${styles.closeModal}`}>x</div>
               {/* <button className={styles.cookiesBtn} onClick={addAdd}>Ok, understood</button> */}
             
                <Link to={`${whichAdd == "mwov" ? '/games/:12' : whichAdd == "keneBrini" ? '/games/:10' : '/games-horror'}`}><Button halloween={props.halloween} xmas={props.xmas} click={closeAdd} size={"large"}>Play Now!!</Button></Link>
           </div>
            </div>
          
            
            }  

               {cookie === true ? '' : 
               <div className={styles.cookies} style={{
                zIndex: cookie === true ? -1 : 20 
               }}>
               <p className={styles.cookiesP}>Nevrycards.com uses analytics, cookies, etc, required to store game data. Further use of the website
                   means that you agree on having cookies, The council informs you because of the legal rights of the above world.
               </p>
               <button className={styles.cookiesBtn} onClick={cookieAdd}>Ok, understood</button>
           </div>
            }  
            <div className={`${styles.navList}`}>
                 <Link onMouseEnter={onHover} onMouseLeave={afterHover} className={`${styles.navListElem} ${styles['navListElem--nevry']}`} to={"/"}><div></div>Nevrycards</Link>
                 <Link onMouseEnter={onHover} onMouseLeave={afterHover} className={`${styles.navListElem}`} to={"/games"}>Games <b>v</b>
                 {hovered == 2 && <NavOptions halloween={props.halloween} xmas={props.xmas} >{props.games.map((val)=>{return <Link to={"/games/:" + val.id}><div className={`${styles.navOptionsElem}`}>{val.name}{val.isNew && <div className={`${styles.navOptionsNew}`}>New!</div>}</div></Link>})}</NavOptions>}
                 </Link>
                {localStorage.getItem('cardsOfHorror') == "true" && <Link onMouseEnter={onHover} onMouseLeave={afterHover} className={`${styles.navListElem} ${styles['navListElem--horror']}`} style={{color:'red'}} to={"/games-horror"}>Cards of Horror<b>v</b>
                 {hovered == 6 && <NavOptions halloween={props.halloween} xmas={props.xmas} >{props.horrorGames.map((val)=>{return <Link to={"/games-horror/:" + val.id}><div className={`${styles.navOptionsElem}`}>{val.name}{val.isNew && <div className={`${styles.navOptionsNew}`}>New!</div>}</div></Link>})}</NavOptions>}
                 </Link>}
                 


                 <div onMouseEnter={onHover} onMouseLeave={afterHover} className={`${styles.navListElem}`}>Community <b>v</b>
                {hovered == 3 && <NavOptions halloween={props.halloween} xmas={props.xmas} >{communityArray.map((val)=>{return <Link to={val.link} target={(val.id <= 5) && '_blank'}><div className={`${styles.navOptionsElem}`}>{val.name}</div></Link>})}</NavOptions>}
                 </div>
                 <Link onMouseEnter={onHover} onMouseLeave={afterHover} className={`${styles.navListElem}`} to={"/passwords"}>Passwords</Link>
              <Link onMouseEnter={onHover} onMouseLeave={afterHover} className={`${styles.navListElem}`} target="_blank" to={"https://ko-fi.com/nevrycards"}>Support!</Link>
                 {/* <Link onMouseEnter={onHover} onMouseLeave={afterHover} className={`${styles.navListElem}`} to={"/updates"}>Updates</Link> */}
                 {props.halloween && <div className={`${styles.pumpkinImage}`}></div>}
                 {props.xmas && <div className={`${styles.pumpkinImage} ${styles['pumpkinImage--xmas']}`}></div>}
            </div>
        </div>
    );
}


export default Navheader;